import "./SevenUpDownCards.scss";
import React from "react";
import { connectSevenUpDown} from "../../SevenUpDown.connect";

const SevenUpDownCards = ({exchangeGames}) => {
    const cardSrc = (card) => {
        if (card) {
            return `https://stream.fawk.app/assets/smallCards/${card}.png`;
        } else {
            return "https://stream.fawk.app/assets/smallCards/BACK.png";
        }
    };

    return (
    <div className="seven-up-down-cards">
      <div className="seven-up-down-cards__player">
        
        <img className="seven-up-down-cards__player-card"
          src={cardSrc(exchangeGames && exchangeGames[0]?.indexCard[0])} alt="card" 
        />
      </div>
    </div>
    );
};
export default connectSevenUpDown()(SevenUpDownCards);
